document.querySelectorAll('[data-product-slider]').forEach((slider) => {
  const track = slider.querySelector('.custom-product-slider__track');
  const slides = slider.querySelectorAll('.custom-product-slide');
  const prev = slider.querySelector('.custom-product-slider__prev');
  const next = slider.querySelector('.custom-product-slider__next');
  let index = 0;
  let autoPlay;
  function updateSlider() {
    const slideWidth = slider.offsetWidth;
    track.style.transform = `translate3d(-${index * slideWidth}px, 0, 0)`;
  }
  function nextSlide() {
    index++;
    if (index >= slides.length) {
      index = 0;
    }
    updateSlider();
  }
  function prevSlide() {
    index--;
    if (index < 0) {
      index = slides.length - 1;
    }
    updateSlider();
  }
  next.addEventListener('click', () => {
    nextSlide();
    resetAutoplay();
  });
  prev.addEventListener('click', () => {
    prevSlide();

    resetAutoplay();
  });
  function startAutoplay() {
    autoPlay = setInterval(() => {
      nextSlide();
    }, 4000);
  }
  function resetAutoplay() {
    clearInterval(autoPlay);

    startAutoplay();
  }
  window.addEventListener('resize', () => {
    updateSlider();
  });
  updateSlider();
  startAutoplay();

});


document.querySelectorAll('[data-scroll-target]').forEach((button) => {
  button.addEventListener('click', () => {
    const targetId = button.dataset.scrollTarget;
    const target = document.getElementById(targetId);
    if (!target) return;
    const offset = 120;
    const top =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      offset;
    window.scrollTo({
      top,
      behavior: 'smooth'
    });

  });

});